import { createLazyComponent, LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "HtmlEditorRibbon"*/ './lazyIndex')
);

// Delay loaded components
export let Ribbon = createLazyComponent(lazyModule, m => m.Ribbon);
export let ContextualFormatBar = createLazyComponent(lazyModule, m => m.ContextualFormatBar);

// Delay load utils
export let lazyFormatPainterFinish = new LazyImport(lazyModule, m => m.formatPainterFinish);
export let lazyShowInsertLinkDialog = new LazyImport(lazyModule, m => m.showInsertLinkDialog);

// export synchronous interfaces
export type { RibbonButton } from './components/buttons/RibbonButton';
export type { RibbonProps } from './components/RibbonProps';

export { InsertLinkSource } from './types/InsertLinkSource';

export { getText } from './utils/getText';
